import type { GrowthPackDefinition } from '../../../domain/industry/types';
import { buildPack, PACK_CONTENT } from './packBuilder';

const growthPacks: GrowthPackDefinition[] = [
  {
    id: 'retail_growth_starter',
    industryId: 'retail_ecom',
    tier: 1,
    name: 'Storefront',
    description: 'PCI basics and marketplace launch.',
    unlocks: {
      missionIds: ['retail_mission_pci'],
      productIds: ['retail_marketplace'],
    },
  },
  {
    id: 'retail_growth_fulfillment',
    industryId: 'retail_ecom',
    tier: 2,
    name: 'Fulfillment',
    description: 'Supply chain security after PCI self-check.',
    unlockConditions: { completedMissionIds: ['retail_mission_pci'] },
    unlocks: {
      missionIds: ['retail_mission_fraud'],
      productIds: ['retail_supply', 'retail_pos'],
    },
  },
  {
    id: 'retail_growth_personalization',
    industryId: 'retail_ecom',
    tier: 3,
    name: 'Personalization',
    description: 'AI recommendations after fraud prevention.',
    unlockConditions: { completedMissionIds: ['retail_mission_fraud'], minBudget: 4000 },
    unlocks: {
      productIds: ['retail_ai'],
    },
  },
];

export const retailEcomPack = buildPack({
  id: 'retail_ecom',
  ...PACK_CONTENT.retail_ecom,
  growthPacks,
  expansionPacks: [
    {
      id: 'retail_exp_omnichannel',
      industryId: 'retail_ecom',
      name: 'Omnichannel Security',
      version: '1.0.0',
      description: 'PCI-DSS and GDPR framework bundle for unified commerce.',
      requiresGrowthTierId: 'retail_growth_fulfillment',
      // Framework ids added when retail entries land in REGULATORY_FRAMEWORKS
      adds: {},
    },
  ],
});